'use server';
import { actionErrorLog } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { getAudioStoryService } from '@/contexts/audio-stories/services/AudioStoryService';

export async function deleteAudioStory(audioStoryId: string): Promise<ActionResult<void>> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };
  try {
    await getAudioStoryService().deleteAudioStory(audioStoryId, familyId);
    return { success: true, data: undefined };
  } catch (e: unknown) {
    actionErrorLog('deleteAudioStory', e);
    return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
  }
}
